// API configuration for all services
// Using relative path /api - nginx will proxy to backend:5000/api
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || '/api'
};

console.log('API Config initialized:', API_CONFIG.baseURL);